export const baseURL = '/api/rest/s1';
export const signingURL = 'http://localhost:13329/signing';